import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState } from 'react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import styled from '@emotion/styled';
import { black } from '@xsite-ui/prequal-funnels.constants';

var _templateObject, _templateObject2, _templateObject3;
var TooltipWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 16px;\n  position: relative;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  max-width: 375px;\n"])));
var TooltipTitle = styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  text-decoration: underline;\n  font-size: 14px;\n  color: ", ";\n  height: 15px;\n  line-height: 16px;\n  cursor: pointer;\n"])), black);
var TooltipText = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: calc(100% - 32px);\n  text-align: left;\n  font-size: 14px;\n  line-height: 20px;\n  background-color: #ecfbf6;\n  padding: 10px 16px;\n  border-radius: 8px;\n  position: relative;\n\n  ", "\n\n  transform: translateY(-4vh) rotateX(20deg);\n  transform-origin: top;\n  color: transparent;\n  z-index: -1;\n  opacity: 0;\n  width: calc(100% - 32px);\n  max-width: calc(92vw - 32px);\n  transition: transform 0.3s, opacity 0.3s, color 0.3s 0.2s;\n\n  ", "\n"])), function (props) {
  return (props === null || props === void 0 ? void 0 : props.hasTitle) && "\n      margin-top: 20px;\n      &:before {\n        width: 15px;\n        height: 15px;\n        box-sizing: border-box;\n        content: '';\n        position: absolute;\n        top: -15px;\n        left: calc(50% - 10px);\n        border-left: 10px solid transparent;\n        border-right: 10px solid transparent;\n        border-bottom: 10px solid #ecfbf6;\n  }";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.showText) && "    \n      position: relative;\n      transform: translate3d(0, 0, 0) rotateX(0deg);\n      z-index: 1;\n      opacity: 1;\n      color: ".concat(black, ";\n      transition: transform 0.5s, opacity 0.5s, color 0.1s;\n    ");
});

var Tooltip = function Tooltip(_ref) {
  var title = _ref.title,
      text = _ref.text,
      _ref$showByDefault = _ref.showByDefault,
      showByDefault = _ref$showByDefault === void 0 ? false : _ref$showByDefault;

  var _useState = useState(showByDefault),
      _useState2 = _slicedToArray(_useState, 2),
      showText = _useState2[0],
      setShowText = _useState2[1];

  var handleToggle = function handleToggle() {
    setShowText(!showText);
  };

  if (!text) {
    return null;
  }

  return /*#__PURE__*/React.createElement(TooltipWrapper, {
    "data-testid": "tooltip-wrapper"
  }, title && /*#__PURE__*/React.createElement(TooltipTitle, {
    onClick: handleToggle,
    "data-testid": "tooltip-title"
  }, title), /*#__PURE__*/React.createElement(TooltipText, {
    showText: !text || showText,
    hasTitle: Boolean(title),
    "data-testid": "tooltip-text",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }));
};

export { Tooltip };
